import { render, staticRenderFns } from "./accident-intruders.vue?vue&type=template&id=1260f02a"
import script from "./accident-intruders.vue?vue&type=script&lang=js"
export * from "./accident-intruders.vue?vue&type=script&lang=js"
import style0 from "./accident-intruders.vue?vue&type=style&index=0&id=1260f02a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports